export default "__VITE_ASSET__XB3Nt8Gp__"